import React, { useCallback, useEffect, useState } from 'react';
import Dialog from '../../../../dialog/Dialog';
import FormPreview from '../FormPreview/FormPreview';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateLearningContinuaPreview,
  updateLearningContinuumForm
} from '../../../../../store/actions/learning-continuum.actions';
import { getLearningContinuaById } from '../../../../../services/learning-continuum/learning-continuum.service';
import { useParams } from 'react-router-dom';
import LearningContinuaSkeleton from '../../../../skeleton/LearningContinuaSkeleton';
import { handlerErrorV2 } from '../../../../../utils/errors';
import DialogLevelsElements from '../LevelsElements/DialogLevelsElements';

const Preview = () => {
  const { curriculumId } = useParams();
  const preview = useSelector((state) => state?.lc?.preview || null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modal, setModal] = useState(null);
  const dispatch = useDispatch();

  const onLoad = useCallback(async () => {
    if (preview) {
      try {
        const response = await getLearningContinuaById(curriculumId, preview);
        if (!response?.data && response?.error) {
          setError(response.error.message || 'An error ocurred');
        } else {
          const formData = response?.data || {};
          formData.levelsElements = formData.levels
          formData.levels = formData.levels.reduce((acc, level) => {
            acc[level.levelId] = level.definition;
            return acc;
          }, {});
          dispatch(updateLearningContinuumForm(formData));
        }
      } catch (error) {
        const message = handlerErrorV2(error);
        setError(message);
      } finally {
        setLoading(false);
      }
    }
  }, [curriculumId, preview]);

  const onClose = () => {
    dispatch(updateLearningContinuaPreview());
    dispatch(updateLearningContinuumForm({}));
  };

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  if (!preview) return <></>;

  return (
    <>
      {modal && (
        <DialogLevelsElements
          open={!!modal}
          onClose={() => setModal(null)}
          formData={modal.form}
          onSave={() => {}}
          type={`${modal.type}`}
          element={modal.element}
        />
      )}
      <Dialog
        id='learning-continua-preview'
        show={!!preview}
        title='learning continua preview'
        onClose={onClose}
        onCloseHeader={true}
        maxWidth='sm'
      >
        {error ? (
          <div>{error}</div>
        ) : loading ? (
          <LearningContinuaSkeleton />
        ) : (
          <FormPreview onElements={(type, element, form) => setModal({ form, type, element })} />
        )}
      </Dialog>
    </>
  );
};

export default Preview;
